<template>
	<CharacteristicEdit
		:value="value"
		title="Tätigkeiten & Aufgaben"
		with-keyword
		:characteristic-items="characteristicItems"
		:characteristic-type="meta.functionType"
		:supplements-config="{
			nothingAllowed: false,
			types: supplementTypes
		}"
		:selected-items-config="{
			showExperience: false
		}"
		:search-config="{ catalog: meta.searchCatalogFunction }"
		label-type="job-profile"
		open-fan-button-alignment="left"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";

export default {

	components: {
		CharacteristicEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		help: {
			type: Object,
			required: false,
		},
	},

	computed: {
		characteristicItems ()
		{
			return this.meta.function;
		},
		supplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		}
	},
}
</script>
